export default (data) => Object.entries(data).map(([key, value]) => value);
